<template>
    <div>
      <v-card class="rounded-xl" elevation="5">
        <v-card-title>
          <v-icon left>
            mdi-account
          </v-icon>
          <span>Primary</span>
          <v-spacer></v-spacer>
          <v-btn @click="openDialog" fab x-small elevation="0" dark color="success"><v-icon dark>mdi-pencil</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="6">
              <label>Name</label>
              <h4>{{mbr.firstName}} {{ mbr.lastName }}</h4>
            </v-col>
            <v-col cols="6">
              <label>Group</label>
              <h4>{{mbr.groupName}}</h4>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dialogIsOpen">
        <!-- v-on="$listeners" to pass showResponse from parent -->
        <PrimaryDetailsForm :mbr="mbr" @closeDialog="closeDialog" v-on="$listeners"/>
      </v-dialog>
    </div>
  </template>
  <script>
  export default {
    components:{
        PrimaryDetailsForm:()=>import("@/components/wesupport/member/primaryDetails/PrimaryDetailsForm.vue")
    },
    data: () => ({
      dialogIsOpen: false,
    }),
    props:{
      mbr:Object,
    },
    mounted() {
  
    },
    methods: {
      openDialog() {
        this.dialogIsOpen = true;
      },
      closeDialog() {
        this.dialogIsOpen = false;
      },
    },
  };
  </script>
  